import React from 'react';

export const MAX_UPLOAD_SIZE = 100000000;
export const UPLOAD_MESSAGE = <>
    <h2 className='text-uppercase text-center font-weight-bold text-gray-900 mb-1'>Uploading...</h2>
    <p className='fs-xl'>Please wait until all the file(s) are uploaded.<br />This might take a while.</p>
</>;